/**
 *  Defines route groups for master, store, and settings routes, 
 * and provides a custom hook to check if the current route matches any of the groups.
 */

import { useLocation } from "react-router-dom";
import RoutesConstants from "../routes/routes-constants";

export const masterRoutes = [
  RoutesConstants.StoreList,
  RoutesConstants.StaffInformation,
  RoutesConstants.CategoryList,
  RoutesConstants.TreatmentList,
  RoutesConstants.ProductList,
  RoutesConstants.OptionMenuList,
  RoutesConstants.HeadquarterManagement,
];

export const storeRoutes = [
  RoutesConstants.StoreDetails,
  RoutesConstants.StoreStaffInformation,
  RoutesConstants.StoreTreatmentList,
  RoutesConstants.StoreProductList,
  RoutesConstants.StoreOptionMenuList,
];

export const variousSettingsRoutes = [
  RoutesConstants.ConsumptionTax,
  RoutesConstants.BusinessTypeSettings,
  RoutesConstants.AgreementList,
  RoutesConstants.ChaneAgreementPassword,
  RoutesConstants.TaxSettings,
  RoutesConstants.TimeSettings,
  RoutesConstants.PaymentModeSettings,
  RoutesConstants.StoreMotivationSettings,
  RoutesConstants.ReservationSettings,
  RoutesConstants.UploadIcons,
  RoutesConstants.MotivationInStore,
  RoutesConstants.PaymentInStore,
  RoutesConstants.EmailManagement
];

export const reservationSettingsRoutes = [
  RoutesConstants.CancelledReservation
];

export const totallingManagementRoutes = [
  RoutesConstants.TotallingManagementDaily,
  RoutesConstants.TotallingManagementMonthly,
  RoutesConstants.TotallingManagementWeekly,

];

export const useIsRouteGroupActive = (routeGroup: string[]) => {
  const location = useLocation();
  return routeGroup.some((route) => location.pathname.startsWith(route));
};
